export const piniWhite = '#DAF7A6'
export const pinaYellow = '#FFC300'
export const cherryRed = '#FF5733'